// This file is generated by bin/generate-theme.ts

// Space design tokens
export const spaces = {
  xs: '2px',
  s: '4px',
  m: '8px',
  l: '16px',
  xl: '24px',
  xxl: '32px',
};

export type SpacesTokens = typeof spaces;
export type SpacesKey = keyof SpacesTokens;
